import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ThemeProvider, useTheme } from './ThemeContext';
import './App.css'; // Import the new CSS file
import Header from './header';
import Card from './card';
import Intro from './Intro';
import LanguagesTools from './skills';
import Achievements from './achievements';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AlgothonPage from './algothon';

const AppContent = () => {
  const { isDarkMode } = useTheme();
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  useEffect(() => {
    const data = [
      {
        id: 1,
        name: 'HireVerse',
        short_description: 'Personalized Leetcode',
        code_url: 'https://github.com/mmc03-ucb/HireVerse',
        tech_stack: 'JavaScript, React, FireBase ',
        Awards: 'Special Mention in DevSoc\'s Blueprint Hackathon 2024',
        devpost_url: 'https://devpost.com/software/test-4i3b9q',
        priority: 4
      },
      {
        id: 2,
        name: 'RallyNow',
        short_description: 'An app to connect and support people during protests in limited internet',
        code_url: 'https://github.com/mmc03-ucb/rallynow',
        tech_stack: 'JavaScript, React Native, FireBase',
        Awards: 'Best Presentation winner in SYNCHack 2024',
        devpost_url: 'https://devpost.com/software/rallynow',
        priority: 5
      },
      {
        id: 3,
        name: 'TikPlayLive',
        short_description: 'TikTok Live with mini-games, betting, and polling',
        code_url: 'https://github.com/mmc03-ucb/TikTok-live-pollling?tab=readme-ov-file',
        tech_stack: 'JavaScript, React Native, MongoDB',
        Awards: 'People\'s Choice and 4th Place Winner in TikTok Tech Jam 2024',
        devpost_url: 'https://devpost.com/software/mmcandco',
        priority: 1
      },
      {
        id: 4,
        name: 'GoalMate',
        short_description: 'An accountability focused goal setting app',
        code_url: 'https://github.com/mmc03-ucb/GoalMate',
        tech_stack: 'Swift',
        Awards: null,
        devpost_url: 'https://devpost.com/software/csesoc-hackathon',
        priority: 7
      },
      {
        id: 5,
        name: 'Interactive Stock Analyzer',
        short_description: 'Web-based tool for real-time stock analysis using technical indicators like RSI and Bollinger Bands',
        code_url: 'https://github.com/mmc03-ucb/InteractiveStockAnalyzer',
        tech_stack: 'Python, yfinance, plotly, dash',
        Awards: null,
        devpost_url: null,
        priority: 2
      },
      {
        id: 6,
        name: 'BeGreen',
        short_description: 'Gamified iOS app that promotes sustainable living through quests and social challenges, tracking and incentivizing environmentally conscious choices',
        code_url: 'https://github.com/mmc03-ucb/BeGreen',
        tech_stack: 'Swift',
        Awards: '2nd place in CalHacks Hack Month 23',
        devpost_url: null,
        priority: 6
      },
      {
        id: 7,
        name: 'AQeye',
        short_description: 'Analyzing and predicting Air Quality data using machine learning, EDA, spatial joins, and interpolation',
        code_url: 'https://github.com/mmc03-ucb/Analyzing-and-Predicting-AQI-Data-through-Modeling',
        tech_stack: 'Python',
        Awards: null,
        devpost_url: null,
        priority: 8
      },
      {
        id: 8,
        name: 'Hog',
        short_description: 'A turn-based dice game simulator with unique scoring and swapping mechanics.\n(CS61A Class Project)',
        code_url: null,
        tech_stack: 'Python',
        Awards: 'Perfect Score + Bonus Points',
        devpost_url: null,
        priority: 9
      },
      {
        id: 9,
        name: 'EdButBetter',
        short_description: 'AI Integrated Course Forum',
        code_url: 'https://github.com/mmc03-ucb/EdButBetter',
        tech_stack: 'React, JavaScript, Firebase, Gemini AI',
        Awards: 'Best UI/UX at DevSoc HackaByte 2025',
        devpost_url: 'https://devpost.com/software/edbutbetter',
        priority: 3
      },
      {
        id: 10,
        name: 'Freerooms',
        short_description: 'A mobile app to help UNSW students find available spaces on campus. DevSoc\'s first mobile application!',
        code_url: 'https://github.com/devsoc-unsw/freerooms-mobile',
        tech_stack: 'Swift, SwiftUI',
        Awards: null,
        devpost_url: null,
        priority: null
      },
      {
        id: 11,
        name: 'Lec-Recall',
        short_description: 'Lec-Recall turns lectures into interactive sessions with live transcription, AI question detection, and instant quiz generation',
        code_url: 'https://github.com/mmc03-ucb/Lec-Recall',
        tech_stack: 'JavaScript, React, Node.js, Express.js, SQLite, GeminiAI, Deepgram',
        Awards: 'Finalist in HackMelbourne 2025',
        devpost_url: 'https://devpost.com/software/lec-recall?_gl=1*6rlvz5*_gcl_au*MjAzMTM2Nzc1Ni4xNzQ5NzYxNTg2*_ga*MTM3ODYxNTcxLjE3NDk3NjE1ODY.*_ga_0YHJK3Y10M*czE3NTczODM2MzUkbzIxJGcxJHQxNzU3MzgzNjU2JGozOSRsMCRoMA..',
        priority: null
      }
    ];

    setProjects(data);
    setFilteredProjects(data);
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = projects.filter((project) =>
      project.tech_stack.toLowerCase().includes(query)
    );
    setFilteredProjects(filtered);
  };

  return (
    <div className="app">
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <main className="main-content">
              <Intro />
              <motion.section 
                className="section"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                <Achievements />
              </motion.section>
              <motion.section 
                className="section"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                <div className="section-header">
                  <h2 className="section-title">Projects</h2>
                  <p className="section-subtitle">
                    (500+ Git Contributions in the last year)
                  </p>
                </div>
                <div className="search-container">
                  <input
                    type="text"
                    placeholder="Search by tech stack..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="search-bar"
                  />
                </div>
                <div className="projects-grid">
                  {filteredProjects.map((project) => (
                    <Card
                      key={project.id}
                      name={project.name}
                      shortDescription={project.short_description}
                      codeUrl={project.code_url}
                      techStack={project.tech_stack}
                      awards={project.Awards}
                      devpost={project.devpost_url}
                    />
                  ))}
                </div>
              </motion.section>
              <motion.section 
                className="section"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                <LanguagesTools />
              </motion.section>
            </main>
          }
        />
        <Route path="/algothon" element={<AlgothonPage />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
};

export default App;

